(function () {
    'use strict';

    // @ngInject
    function FullStoryServiceCtor(FS, ExceptionService, AppConfigService, TrackJS) {
        this.FS = FS;
        this.isTracking = false;
        this.ExceptionService = ExceptionService;
        this.AppConfigService = AppConfigService;
        this.TrackJS = TrackJS;
        this.shouldTrackEvaluated = false;
        this.sessionsSampleSize = 3;
    }


    Services.FullStoryService = Class(function () {
        return {
            constructor: FullStoryServiceCtor,

            initTracking: function (user) {
                var segment = user.account && user.account.predicted_member_segment ? user.account.predicted_member_segment : null;
                if (!this.shouldTrackEvaluated && this.should_track(segment) && !this.isTracking && this.FS && this.FS.getCurrentSession) {
                    try {
                        if (!this.FS.getCurrentSession()) {
                            this.FS.restart(); // we need to call restart if we called shutdown before (called on page load and user logout and such)
                        }
                        this.FS.identify(user._id, {
                            displayName: user.full_name,
                            email: user.email,
                            userType_str: user.system_user_type,
                            isActivated_bool: user.isActivated && user.isActivated(),
                            activatedOn_date: user.activated_on ? new Date(user.activated_on) : null,
                            isMobileActive_bool: user.is_mobile_active,
                            companyType_str: user.company.company_type,
                            trialStartDate_date: user.company.trial && user.company.trial.start_date ? new Date(user.company.trial.start_date) : null,
                            featuresActive_str: (user.features_active ? user.features_active.join(',') : ''),
                            segmentPrediction_str: user.account && user.account.predicted_member_segment ? user.account.predicted_member_segment : null
                        });
                        this.isTracking = true;
                    } catch (e) {
                        this.TrackJS && this.TrackJS.track(e);
                    }
                }
            },

            should_sample_session: function should_sample_session(sampleSize) {
                // we want to record 66% of the sessions
                return Math.round(Math.random()*(sampleSize-1)+1) !== sampleSize;
            },

            should_track_segment: function should_track_segment(segment) {
                return (!segment || segment === "20K - 50K" || segment === "50K - 200K" || segment === "200K+")
            },

            should_track: function should_track(segment) {
                this.shouldTrackEvaluated = true;
                return this.should_track_segment(segment) && this.should_sample_session(this.sessionsSampleSize);
            },

            stopTracking: function () {
                this.shouldTrackEvaluated = false;
                if (this.isTracking && this.FS) {
                    try {
                        this.FS.identify(false); // this clears the user details and starts a new session
                        this.FS.shutdown();
                        this.isTracking = false;
                    }
                    catch (e) {
                        this.TrackJS && this.TrackJS.track(e);
                    }
                }
            },

            trackEvent: function (eventName, eventProps) {
                if (this.isTracking && this.FS) {
                    this.FS.event(eventName, eventProps);
                }
            }
        };
    });

}());
